import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Etablissement } from '@teetsh/app/src/types/etablissement';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import Button from 'components/Buttons/Button';
import {
  getEtablissementCity,
  getEtablissementPostalCode,
  getEtablissementAddress,
} from './etablissementHelpers';

interface Props {
  etablissement: Etablissement;
  onClear: () => void;
}

export function SelectedSchool({ etablissement, onClear }: Props) {
  const { name } = etablissement;
  const address = getEtablissementAddress(etablissement);
  const postalCode = getEtablissementPostalCode(etablissement);
  const city = getEtablissementCity(etablissement);
  const { t } = useTranslation(['common', 'schoolyearSettings']);

  const uai = 'uai' in etablissement ? etablissement.uai : undefined;
  const district =
    'district' in etablissement ? etablissement.district : undefined;
  const state = 'state' in etablissement ? etablissement.state : undefined;

  return (
    <div
      tw="bg-white rounded-lg border border-brand-quiet p-4 flex items-start justify-between transition-opacity duration-300 ease-in-out"
      css={`
        @starting-style {
          opacity: 0;
        }
      `}
    >
      <div tw="flex-grow">
        <p tw="font-bold text-neutral-moderate text-base mb-1">{name}</p>
        <p tw="text-neutral-moderate text-sm mb-1">
          {address && `${address}, `}
          {postalCode && `${postalCode}, `}
          {city}
        </p>
        <p tw="text-neutral-quiet text-sm">
          {uai && (
            <>{`${t(
              'schoolyearSettings:schoolGeneral.nationalIdentifier',
            )} : ${uai}`}</>
          )}
          {district && (
            <>{`${t(
              'schoolyearSettings:schoolGeneral.district',
            )} : ${district}`}</>
          )}
          {state && <>{`State: ${state}`}</>}
        </p>
      </div>
      <Button
        onClick={onClear}
        minimal
        aria-label="Désélectionner l'école"
        icon={XMarkIcon}
      />
    </div>
  );
}
